<template>
  <div class="audio-editor-container">
    <div id="timeline" ref="timeline" />
    <div id="waveform" ref="waveform"></div>

    <div class="button-all">
      <el-button type="primary" @click="play">播放</el-button>
      <el-button type="info" @click="pause">暂停</el-button>
      <el-button type="danger" @click="stop">停止</el-button>
      <el-button @click="audition">试听</el-button>
      <el-button type="success" @click="add">添加</el-button>
      <div class="icon-outline">
        <span class="el-icon-phone-outline" @click="onVolumeSwitch"></span>
        <div class="block">
          <el-slider
            v-model="volume"
            vertical
            height="50px"
            @input="volumeInput">
          </el-slider>
         </div>
      </div>
    </div>
    <p>当前播放时间：{{currentTime}} / {{totalTime}}</p>
    <p>音频片段时间：
      <el-input v-model="regionalTime.startTime" placeholder="开始时间" maxlength="12" size="mini" style="width: 110px;" @blur="inputBlur('startBlur')"></el-input> — 
      <el-input v-model="regionalTime.endTime" placeholder="结束时间" maxlength="12" size="mini" style="width: 110px;" @blur="inputBlur('endBlur')"></el-input>
      <el-button @click="onResetTime">重置</el-button>
    </p>

    <el-table :data="tableData" border style="width: 100%" :row-class-name="tableRowClassName">
      <el-table-column
        type="index"
        label="序号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="name"
        label="音频片段名称"
        width="150">
      </el-table-column>
      <el-table-column
        label="音频片段起止时间"
        width="250">
        <template slot-scope="scope">
          <span>{{scope.row.startTime}}</span> — <span>{{scope.row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleAudition(scope.$index, scope.row)">试听</el-button>
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="音频片段名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addRegional">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import WaveSurfer from 'wavesurfer.js'
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline'//Timeline插件
import Region from 'wavesurfer.js/dist/plugin/wavesurfer.regions'//regions插件
import Cursor from 'wavesurfer.js/dist/plugin/wavesurfer.cursor'

export default {
  name: 'audio-editor',
  components: {},
  data() {
    return {
      wavesurfer: null,
      percent: null,
      speed: 1,
      tableData: [],
      currentTime: '00:00:00.000', // 当前播放时间
      totalTime: '00:00:00.000', // 音频总时长
      // 区域时间
      regionalTime: {
        startTime: '00:00:02.000',
        endTime: '00:00:05.000',
      },
      dialogTitle: '添加音频片段',
      dialogFormVisible: false,
      form: {
        id: '',
        name: '',
        startTime: '',
        endTime: '',
      },
      formLabelWidth: '120px',
      volume: 50, // 默认音量
      volumeState: true, // 音量开关状态 true:有音量
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.wavesurfer = WaveSurfer.create({
        // container: this.$refs.waveform,//绑定容器，第一种方法
        // container: document.querySelector('#waveform'),//第二种方法
	      container: '#waveform',//第三种方法
        audioRate: this.speed, // 播放音频的速度。数字越低，速度越慢。
        forceDecode: true, // 在缩放时使用web audio强制解码音频，以获得更详细的波形。
        backgroundColor: '#2B3245', // 更改波形容器的背景颜色。
        waveColor: '#368666', // 波纹颜色
        progressColor: 'skyblue', // 播放波纹颜色
        cursorColor: 'skyblue', // 播放进度线颜色
        // backend: 'MediaElement', // WebAudio、MediaElement或MediaElementWebAudio。MediaElement是不受支持浏览器的后备方案。
        barWidth: 3, // 控制波纹宽度
        height: 80, // 波形的高度。以像素为单位测量。
        plugins: [
          Timeline.create({
            container: '#timeline',//绑定容器
            labelPadding: 2
          }),
          Region.create(),
          Cursor.create({
		      	showTime: true,
		      	opacity: 1,
		      	customShowTimeStyle: {
		      		'background-color': '#000',
		      		color: '#fff',
		      		padding: '2px',
		      		'font-size': '10px'
		      	}
		      })
        ],
      })

      this.createRegion() // 创建音频选中区域
      this.load() // 执行绑定事件

    },
    // 创建音频选中区域
    createRegion(start, end) {
      this.currentRegion = this.wavesurfer.addRegion({
        // id: id, // region的id
        start: start ? start : 2, // region的开始位置，单位秒
        end: end ? end : 5, // region的结束位置，单位秒
        loop: false, // 播放完毕后是否循环播放
        // drag: false, // 是否支持拖拽
        // resize: false, // 是否支持改变region的大小
        color: "rgba(254, 255, 255, 0.4)", // 	region的颜色
        // dragSelection: {
        //   slop: 5
        // }
      });
    },
    load() {
      let _this =this
      //加载音频
      this.wavesurfer.load(
        'http://10.1.138.24:9000/aishixun/20210811/11/744008024aff4235ae56c0702ac144ca.mp3'
      )

      // 加载时候
      this.wavesurfer.on('loading', (percents) => {
        // 当前加载的进度
        console.log('当前加载的进度')
        this.percent = percents;
      })
      // 加载成功
      this.wavesurfer.on('ready', function() {
        console.log('// 加载成功');
        _this.totalTime = _this.changeTime(_this.wavesurfer.getDuration()); // 获取音频总时长
      })
      // 播放中
      this.wavesurfer.on('audioprocess', function(e) {
      	_this.currentTime = _this.changeTime(_this.wavesurfer.getCurrentTime()) // 获取当前播放时间
      })
      // 结束播放
      this.wavesurfer.on("finish", () => {
        // _this.wavesurfer.pause();
      });

      // 区域
      this.wavesurfer.on('region-click', (region, mouseEvent)=> {
        console.log('区域点击',region,mouseEvent);
        const { start, end } = region;
        _this.regionalTime = {
          startTime: _this.changeTime(start),
          endTime: _this.changeTime(end),
        };
      	// region.play() // 播放当前区域，另一种播放方式： this.wavesurfer.play(start, end)
        // let s = parseInt(region.start)
        // let e = parseInt(region.end)
        // _this.wavesurfer.play(s, e)
      })
      this.wavesurfer.on('region-created', (region)=> {
        console.log('区域创建',region);
      })

      // 区域更新
      this.wavesurfer.on('region-update', (region) => {
        console.log('区域更新',region);
      })
      // 区域更新结束
      this.wavesurfer.on('region-update-end', (region) => {
        console.log('区域更新结束',region);
        const { start, end } = region;
        _this.regionalTime = {
          startTime: _this.changeTime(start),
          endTime: _this.changeTime(end),
        };
      	/** 播放区域的两种方式 */
      	// this.wavesurfer.play(this.currentRegion.start, this.currentRegion.end)//①
      	// region.play();// ②
          
      	/** 新增区域列表 */
        //wavesurfer.regions.list:获取音频中的区域列表
      	_this.regionList = Object.values(_this.wavesurfer.regions.list);
      })

      
    },

    // 音量开关
    onVolumeSwitch() {
      this.volumeState = !this.volumeState
      if (this.volumeState) {
        this.wavesurfer.setVolume(this.volume/100) // 设置音量0-1，0：静音
      } else {
        this.wavesurfer.setVolume(0) // 设置音量0-1，0：静音
      }
    },
    // 设置音量
    volumeInput(val) {
      this.wavesurfer.setVolume(val/100) // 设置音量0-1，0：静音
    },

    // 时间格式化 seconds/单位秒
    changeTime(seconds) {
    	seconds = Number(seconds);
      var hour = Math.floor(seconds / 60 / 60);
      var minutes = Math.floor(seconds / 60) % 60
        seconds = seconds % 60;
    	var secondsStr = Math.round(seconds).toString()
        secondsStr = seconds.toFixed(3);

      let hh = hour > 0 ? (hour < 10 ? '0' + hour : hour) : '00';
      let mm = minutes > 0 ? (minutes < 10 ? '0' + minutes : minutes) : '00';
      let ss = seconds < 10 ? '0' + secondsStr : secondsStr;
      
      // console.log(hh, mm, ss)
      
      return `${hh}:${mm}:${ss}`

    	// if (minutes > 0) {
    	// 	return `00:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + secondsStr : secondsStr}`
    	// }
    	// return `00:00:${seconds < 10 ? '0' + secondsStr : secondsStr}`
    },

    // 输入时间片段失焦触发
    inputBlur(state) {
      let data = this.regionalTime;
      // let reg = /^[0-9]\d:[0-5]\d+[\.][0-9]{3}$/; // 判断字符串是否为时间格式： 00:00.000
      let reg = /^(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d+[\.][0-9]{3}$/; // 判断字符串是否为时间格式： 23:59:59.000
      let flng = state === 'startBlur' ? reg.test(data.startTime) : reg.test(data.endTime)
      console.log(flng)
      if (flng) {
        let starthh = data.startTime.split(':')[0] * 60 * 60,
         startmm = data.startTime.split(':')[1] * 60,
         startss = parseFloat(data.startTime.split(':')[2]);
        let endhh = data.endTime.split(':')[0] * 60 * 60,
         endmm = data.endTime.split(':')[1] * 60,
         endss = parseFloat(data.endTime.split(':')[2]);

        let start = starthh + startmm + startss
        let end = endhh + endmm + endss
        this.currentRegion.remove() // 删除原有区域
        if (start > end) {
          if (state === 'startBlur') {
            this.regionalTime.endTime = this.changeTime(start)
            this.createRegion(start, start) // 创建音频选中区域
          } else {
            this.regionalTime.startTime = this.changeTime(end)
            this.createRegion(end, end) // 创建音频选中区域
          }
        } else {
          this.createRegion(start, end) // 创建音频选中区域
        }
      } else {
        this.$message.error('时间格式不正确，正确格式为：23:59:59.000')
      }
    },

    // 重置选中音频片段时间
    onResetTime() {
      this.regionalTime = {
        startTime: '00:00:02.000',
        endTime: '00:00:05.000',
      }
      this.currentRegion.remove() // 删除原有区域
      this.createRegion() // 创建音频选中区域
    },

    // 播放音频
    play(){
     this.wavesurfer.play()
    },
    // 暂停音频
    pause(){
     this.wavesurfer.pause()
    },
    // 停止音频回起点
    stop(){
     this.wavesurfer.stop()
    },
    // 试听选中音频片段
    audition(){
      let data = this.regionalTime;
      let starthh = data.startTime.split(':')[0] * 60 * 60,
       startmm = data.startTime.split(':')[1] * 60,
       startss = parseFloat(data.startTime.split(':')[2]);
      let endhh = data.endTime.split(':')[0] * 60 * 60,
       endmm = data.endTime.split(':')[1] * 60,
       endss = parseFloat(data.endTime.split(':')[2]);

      let start = starthh + startmm + startss
      let end = endhh + endmm + endss

      this.currentRegion.remove() // 删除原有区域
      this.createRegion(start, end) // 创建音频选中区域
      this.currentRegion.play()
    },
    // 添加音频片段
    add(){
      this.dialogTitle = '添加音频片段'
      if (this.regionalTime.endTime.indexOf('00:00.000') !== -1) {
        return this.$message.error('请选择音频片段!')
      }
      this.form = {
        id: '',
        name: '',
        startTime: '',
        endTime: '',
      },
      this.dialogFormVisible = true
    },
    addRegional() {
      if (this.form.name) {
        if (this.dialogTitle === '添加音频片段') {
          let timesId = new Date().getTime().toString();
          let data = {}
          data.id = timesId
          data.name = this.form.name
          data.startTime = this.regionalTime.startTime
          data.endTime = this.regionalTime.endTime
          this.tableData.push(data)
        } else { // 编辑音频片段
          this.tableData.map(item => {
            if (item.id === this.form.id) {
              item.name = this.form.name
              // item.startTime = this.regionalTime.startTime
              // item.endTime = this.regionalTime.endTime
            }
          });
        }
        this.dialogFormVisible = false
      } else {
        this.$message.error('名称不能为空!')
      }
    },

    tableRowClassName({ row, rowIndex }) {
    	if (this.currentRegion.id === row.id) {//通过区域id来判断
    		return 'success-row'
    	}
    	return ''
    },
    // 列表试听
    handleAudition(index, row) {
      console.log(index, row);
      let data = this.tableData[index];
      // let start = data.startTime.split(':')[0] * 60 + parseFloat(data.startTime.split(':')[1])
      // let end = data.endTime.split(':')[0] * 60 + parseFloat(data.endTime.split(':')[1])
      let starthh = data.startTime.split(':')[0] * 60 * 60,
       startmm = data.startTime.split(':')[1] * 60,
       startss = parseFloat(data.startTime.split(':')[2]);
      let endhh = data.endTime.split(':')[0] * 60 * 60,
       endmm = data.endTime.split(':')[1] * 60,
       endss = parseFloat(data.endTime.split(':')[2]);

      let start = starthh + startmm + startss
      let end = endhh + endmm + endss
      this.currentRegion.remove() // 删除原有区域
      this.createRegion(start, end) // 创建音频选中区域
      this.currentRegion.play() // 播放区域音频
    },
    // 列表编辑
    handleEdit(index, row) {
      console.log(index, row);
      this.dialogTitle = '编辑音频片段'
      if (this.regionalTime.endTime.indexOf('00:00.000') !== -1) {
        return this.$message.error('请选择音频片段!')
      }
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogFormVisible = true
    },
    // 列表删除
    handleDelete(index, row) {
      console.log(index, row);
      this.tableData.splice(index, 1);
    }
  },
  beforeMount() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
}
</script>
<style lang="scss" scoped>
.audio-editor-container {
  width: 100%;
  height: 100%;
  #waveform {
    // background-color: #2B3245;
    position: relative;
  }

  .el-table .success-row {
    background: #d9e2f8;
  }

  /deep/.wavesurfer-region {
    z-index: 3 !important;
    // background: rgba($color: #000000, $alpha: 0.3) !important;
  }

  .button-all {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  .icon-outline {
    // width: 20px;
    // height: 20px;
    font-size: 20px;
    // padding: 15px;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
    &:hover {
      .block {
        display: inline-block;
      }
    }
    .block {
      display: none;
      position: absolute;
      left: -5px;
      top: -50px;
      z-index: 9;
      /deep/.el-slider__button {
        width: 10px;
        height: 10px;
      }
    }
  }
}
</style>
